<template>
  <div class="devices">
    <devicesList ref="list"></devicesList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import devicesList from './devicesList.vue'

export default {
  components: {
    devicesList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.devices {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/devices/devices.vue